import { render } from "./TruncatedLinkValue.vue?vue&type=template&id=16c357f7&scoped=true&lang=pug"
import script from "./TruncatedLinkValue.vue?vue&type=script&lang=js"
export * from "./TruncatedLinkValue.vue?vue&type=script&lang=js"

import "./TruncatedLinkValue.vue?vue&type=style&index=0&id=16c357f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c357f7"]])

export default __exports__